import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template"
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterUser_template} from "./filterUser_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {filterArticle_template} from "./filterArticle_template";

declare var ko: any;
interface Option {id: number; name: string;}
interface ContentType extends Option {description: string;}
interface Intent extends Option { description: string;}
interface PostPaymentCategory extends Option { description: string;}
interface NetworkCategory extends Option {}
interface Volume  {
    id: number,
    name: string;
    publishCount: number;
    republishCount: number;
    totalArticlesCount: number;
    submittedCount: number;
    publishPageViews: number;
    republishPageViews: number;
    totalPageViews: number
}

export class production_volume_report_template extends vnTemplate{

    protected userType: filterDropdown_template;
    protected intentFilter : multipleSelector_template;
    protected contentTypeFilter : multipleSelector_template;
    protected networkCategoryFilter : multipleSelector_template;
    protected paymentCategoryFilter : multipleSelector_template;
    protected userFilter: filterUser_template;
    protected dateFilter: filterDate_template;
    protected resultInfos: resultsInfo_template;
    protected simpleFilter: filterSimple_template;
    protected pagination: pagination_template;
    protected rangeFilter: filterDropdown_template;
    protected filterPreset: filterPreset_template;

    protected getTemplateHtml(): string{

        return `
            <div class="sub-header filter-preset w-justify ">

                    ` + this.filterPreset.getHtmlBuild() + `
            </div>

            <div id="list-references">
                <div class="sub-header w-justify">

                    <div class="w-left">
                         <div>
                            <label class="form-label form-label-box">user type</label>
                            ${ this.userType.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label form-label-box">Pageview Range</label>
                            ${ this.rangeFilter.getHtmlBuild() }
                        </div>
                        ${ this.intentFilter.getHtmlBuild() }
                        ${ this.contentTypeFilter.getHtmlBuild() }
                        ${ this.networkCategoryFilter.getHtmlBuild() }
                        ${ this.paymentCategoryFilter.getHtmlBuild() }
                        ${ this.userFilter.getHtmlBuild() }
                        ${ this.dateFilter.getHtmlBuild() }
                    </div>
                </div>

            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-payment_categories"></div>
                   <div id="selected-users"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div class="w-left">
                        <button class="btn icon i-export" type="button" data-bind="event: { click: onClickExport }">Export</button>
                </div>
                <div class="w-center">
                    ${ this.simpleFilter.getHtmlBuild() }
                </div>
                <div class="w-right">
                    ${ this.pagination.getHtmlBuild() }
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${  this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">id</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishCount') }, css: { 'list-sort-desc': orderByAndDirection()=='publishCount_DESC', 'list-sort-asc': orderByAndDirection()=='publishCount_ASC' }">Publish Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'republishCount') }, css: { 'list-sort-desc': orderByAndDirection()=='republishCount_DESC', 'list-sort-asc': orderByAndDirection()=='republishCount_ASC' }">Republish Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalArticlesCount') }, css: { 'list-sort-desc': orderByAndDirection()=='totalArticlesCount_DESC', 'list-sort-asc': orderByAndDirection()=='totalArticlesCount_ASC' }">Total Articles Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'submittedCount') }, css: { 'list-sort-desc': orderByAndDirection()=='submittedCount_DESC', 'list-sort-asc': orderByAndDirection()=='submittedCount_ASC' }">Submitted Count</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishPageViews') }, css: { 'list-sort-desc': orderByAndDirection()=='publishPageViews_DESC', 'list-sort-asc': orderByAndDirection()=='publishPageViews_ASC' }">Publish Pageviews</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'republishPageViews') }, css: { 'list-sort-desc': orderByAndDirection()=='republishPageViews_DESC', 'list-sort-asc': orderByAndDirection()=='republishPageViews_ASC' }">Republish Pageviews</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalPageViews') }, css: { 'list-sort-desc': orderByAndDirection()=='totalPageViews_DESC', 'list-sort-asc': orderByAndDirection()=='totalPageViews_ASC' }">Total Pageviews</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'publishSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='publishSessions_DESC', 'list-sort-asc': orderByAndDirection()=='publishSessions_ASC' }">Publish Sessions</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'republishSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='republishSessions_DESC', 'list-sort-asc': orderByAndDirection()=='republishSessions_ASC' }">Republish Sessions</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'totalSessions') }, css: { 'list-sort-desc': orderByAndDirection()=='totalSessions_DESC', 'list-sort-asc': orderByAndDirection()=='totalSessions_ASC' }">Total Sessions</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: volumes">

                        <tr>

                            <td><span data-bind="text: id"></span></td>
                            <td><span data-bind="text: name"></span></td>
                            <td><span data-bind="text: Number(publishCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(republishCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(totalArticlesCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(submittedCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(publishPageViews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(republishPageViews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(totalPageViews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(publishSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(republishSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                            <td><span data-bind="text: Number(totalSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                        </tr>

                    </tbody>
                </table>
            </div>

            `;
    }

    protected initPartial(): void{

        this.userType = new filterDropdown_template('userType', this.getTemplateViewModel(), this.caller);
        this.userType.setLabel("user type");
        this.userType.setOptions( [
            {id: 'idAuthor', name: 'Author'},
            {id: 'idJuniorEditor', name: 'Junior Editor'},
            {id: 'idEditor', name: 'Senior Editor'}
        ]);

        this.rangeFilter = new filterDropdown_template('rangeFilter', this.getTemplateViewModel(), this.caller);
        this.rangeFilter.setLabel('Range');
        this.rangeFilter.setOptions([
            {"id": 0, "name": "Default"},
            {"id": 30, "name": "30 Days"},
            {"id": 60, "name": "60 Days"},
            {"id": 90, "name": "90 Days"}
        ]);

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("intent");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected intents:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content_types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("network category");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network_categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.paymentCategoryFilter = new multipleSelector_template("paymentCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.paymentCategoryFilter.setLabel("payment category");
        this.paymentCategoryFilter.setFilterContainerClass('margin-neg');
        this.paymentCategoryFilter.setTagContainerId('selected-payment_categories');
        this.paymentCategoryFilter.setTagContainerCaption('Selected payment categories:');

        this.userFilter = new filterUser_template("userFilter", this.getTemplateViewModel(), this.caller);
        this.userFilter.asMultipleSelectionMode();
        this.userFilter.setTagContainerId('selected-users');
        this.userFilter.setTagContainerCaption('Selected user:');
        this.userFilter.setPlaceholderText("User");
        this.userFilter.setUniqueIdentifier('userId');

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.setDateRange(this.getFirstDayOfCurrentMonth(), this.getLastDayOfCurrentMonth());

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('prodVolumeReport');
    }

    private getFirstDayOfCurrentMonth(): Date {
        let date = new Date();

        return  new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0);
    }

    private getLastDayOfCurrentMonth(): Date {

        let date = new Date();

        return  new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59);
    }

    protected getTemplateName(): string{
        return "production-volume-report-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-content"];
    }

    protected buildViewModel(): any{

        let self = this;
        return{
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            volumes: ko.observableArray([]),
            orderByAndDirection: ko.observable("name_ASC"),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickExport: function (data, event) { self.onClickExport(); }
        };
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public getViewModelForRequest(){

        return {
            orderBy: this.viewModel.list.orderBy,
            orderByDirection: this.viewModel.list.orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: 'prodVolumeReport',
            filters: {
                userType: this.getTemplateViewModel().userType.selectedOption,
                intents: this.getTemplateViewModel().intentFilter.selectedItems,
                contentTypes: this.getTemplateViewModel().contentTypeFilter.selectedItems,
                networkCategories: this.getTemplateViewModel().networkCategoryFilter.selectedItems,
                paymentCategories: this.getTemplateViewModel().paymentCategoryFilter.selectedItems,
                users: this.userFilter.getUsersForRequest(),
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keyword: this.getTemplateViewModel().simpleFilter.filterKeyword,
                range: this.getTemplateViewModel().rangeFilter.selectedOption,
            },
        };
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.articlesListReorder();
    }

    public setVolumes(volumes: Array<Volume>): void {

        this.getTemplateViewModel().volumes(volumes);
    }

    public setResultInfo(nbResults, nbPages, execTime ){

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setIntentFilterItems(intents: Array<Intent>){

        this.intentFilter.setItems(intents);
    }

    public setPaymentCategoryFilterItems(postPaymentCategories: Array<PostPaymentCategory>){

        postPaymentCategories.forEach((postPaymentCategory) => {
            if(!isNaN(Number(postPaymentCategory.id))){
                postPaymentCategory.id = Number(postPaymentCategory.id);
            }
        });
        this.paymentCategoryFilter.setItems(postPaymentCategories);
    }

    public setNetworkCategoryFilterItems(groupCategories){

        let groups = [];
        for ( let groupCategory of groupCategories){

            groups.push({"name" : groupCategory.name, "items" :groupCategory.networkCategories});
        }
        this.networkCategoryFilter.setMultiSectionItems(groups);
    }

    public setContentTypeFilterItems(contentTypes: Array<ContentType>){

        this.contentTypeFilter.setItems(contentTypes);
    }

    public setUserFilter(users) {

        this.getTemplateViewModel().userFilter.users(users);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            // date filters.
            if(urlParams.dateFilterType){
                this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType)
            }
            if(urlParams.startDateRange || urlParams.endDateRange){

                this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }

            if(urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            this.getTemplateViewModel().userType.selectedOption(urlParams.userType);
            this.getTemplateViewModel().rangeFilter.selectedOption(urlParams.range);

            this.setFilterSelectedItems(this.intentFilter, urlParams.intents);
            this.setFilterSelectedItems(this.contentTypeFilter, urlParams.contentTypes);
            this.setFilterSelectedItems(this.networkCategoryFilter, urlParams.networkCategories);
            this.setFilterSelectedItems(this.paymentCategoryFilter, urlParams.paymentCategories);

            if(urlParams.users) {
                this.userFilter.setSelectedUsersFromRequestParams(urlParams.users);
            } else {
                this.userFilter.resetTagContainer();
            }

            let keywordString = urlParams.keyword
            if(urlParams.keyword){
                keywordString = urlParams.keyword.replaceAll("+", " ");
            }
            this.simpleFilter.getTemplateViewModel().filterKeyword(keywordString);
        }
    }

    public setSearchPresets(presets){
        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){
        this.filterPreset.addCreatedPresetToList(response);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams){
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    private setUserPresetFilter(userFilter: filterUser_template, idUser?: number, name?: string): void {

        userFilter.getTemplateViewModel().idUser(idUser);
        userFilter.getTemplateViewModel().user(name);
        userFilter.toggleCloseButton();
    }

    private setDateFilters(startDate, endDate) {
        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setDefaults(){

        this.dateFilter.setDateRange(this.getFirstDayOfCurrentMonth(), this.getLastDayOfCurrentMonth());
    }

    public onClickExport(){

        this.caller.getExportData();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/production_volume_report_template.ts